/*
 * Projects Page - Carousel
 *
 **/

custom.projectsCarousel = (() => {
  const $carousel = $('.js-projects-carousel');
  const WIDTH_BREAKPOINT = 560; // Mobile breakpoint, consistent when $grid-small in variables.scss
  let isSlick = false;

  function initSlick() {
    //in page carousel
    $carousel.slick({
      arrows: true,
      //appendArrows: $('.js-projects-carousel-arrows'),
      //centerMode: true,
      prevArrow: '.js-projects-carousel-arrows-prev',
      nextArrow: '.js-projects-carousel-arrows-next',
      //autoplay: true,
      //autoplaySpeed: 0,
      //cssEase: 'ease',
      draggable: false,
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      //speed: 12000,
      variableWidth: true,
    });
  }

  function destroySlick() {
    $carousel.slick('unslick');
  }

  function slickHandler() {
    const windowWidth = $(window).width();

    if (!isSlick && windowWidth >= WIDTH_BREAKPOINT) {
      initSlick();
      isSlick = true;
    }

    if (isSlick && windowWidth < WIDTH_BREAKPOINT) {
      destroySlick();
      isSlick = false;
    }
  }

  function init() {
    slickHandler();
    galleryHandler();
    $(window).on('resize', slickHandler);
  }

  /********************
   * MODAL GALLERY
   */
  $stsGallery = $('.gallery'); // Gallery container
  $stsSlick = $stsGallery.find('.gallery__images'); // Main slideshow container for slick

  function galleryHandler() {
    // Subscribe to afterChange event
    $stsSlick.on('init', captionHandler);
    $stsSlick.on('afterChange', captionHandler);

    // Slick initialization
    let slickConfig = {
      infinite: true,
      lazyLoad: 'ondemand',
      prevArrow: '<button class="gallery__prev"></button>',
      nextArrow: '<button class="gallery__next"></button>',
      dots: true,
      autoplay: false,
      initialSlide: 0,
      cssEase: 'linear',
      speed: 200,
      fade: true,
      customPaging: (slider, i) =>
        i + 1 + ' <span>of</span> ' + slider.slideCount,
    };

    let firstOpen = true;
    $('.js-projects-carousel-link').on('click', function () {
      if (firstOpen) {
        //https://stackoverflow.com/questions/48254835/slick-slider-width-0-on-initial-page-load
        $stsSlick.slick(slickConfig);
        firstOpen = false;
      }
      $stsSlick.slick('slickGoTo', $(this).data('gallery-index') - 1);
    });
    $('.js-projects-carousel-link').magnificPopup({
      type: 'inline',
    });

    $(document).ready(function () {
      if ($stsSlick.length && $(window).width() > 768) {
        // Note: Keydown events are firing shortly after page load on the dev and prod sites but not locally. Not sure why, could be one of our plugins.
        $stsSlick.on('mousemove', getCursorPositionSide);
        $stsSlick.on('click', slideController);
        $(this).keyup(function (e) {
          if (e.keyCode == '37' || e.keyCode == '39') {
            e.preventDefault();
            slideController(e);
          }
        });
      } else {
        $stsSlick.on('click', slideController);
      }
    });
  }

  function slideController(event = null) {
    if (event.type == 'keyup' && event.keyCode) {
      //arrow keys
      if (event.keyCode == '37') return $stsSlick.slick('slickPrev');
      if (event.keyCode == '39') return $stsSlick.slick('slickNext');
    } else {
      //left/right side of screen
      return event.pageX > $stsSlick.width() / 2
        ? $stsSlick.slick('slickNext')
        : $stsSlick.slick('slickPrev');
    }
  }

  function changeCursor(side = '') {
    const opposite = side == 'left' ? 'right' : 'left';
    if ($stsSlick.hasClass(`gallery__images--${opposite}`))
      $stsSlick.removeClass(`gallery__images--${opposite}`);
    if (!$stsSlick.hasClass(`gallery__images--${side}`))
      $stsSlick.addClass(`gallery__images--${side}`);
  }

  function getCursorPositionSide(event = null) {
    return event.pageX > $stsSlick.width() / 2
      ? changeCursor('right')
      : changeCursor('left');
  }

  // Handler for Slick
  function captionHandler(e, slick, currentSlideIndex) {
    const $currentSlide = $(this).find('.slick-current');
    const $currentImageElement = $currentSlide.find('[data-caption]');
    $('.js-gallery-caption').html($currentImageElement.data('caption'));
  }

  return {
    init: init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/project-carousel.js